export default __webpack_public_path__ + "static/media/PlantsForDinner_07.acd45385.png";